import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const DeliveryTracking = () => {
  const [currentLocation, setCurrentLocation] = useState(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  useEffect(() => {
    const watchId = navigator.geolocation.watchPosition(
      async (position) => {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;

        const location = {
          lat: latitude,
          lng: longitude,
        };

        setCurrentLocation(location);

        // try {
        //   await axios.put("/api/delivery-partner/update-location", {
        //     latitude,
        //     longitude,
        //   });
        // } catch (error) {
        //   console.log(error);
        // }
      },
      (error) => {
        console.log(error);
      },
      {
        enableHighAccuracy: true,
        maximumAge: 10000,
        timeout: 15000,
      }
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
    };
  }, []);

  if (!isLoaded) return <div>Loading Map...</div>;

  return (
    <div className="page-wrapper">
      <div className="container-xl">
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">Delivery Partner Tracking</h3>
          </div>

          <div className="card-body">
            {currentLocation && (
              <>
                <div className="mb-3">
                  <strong>Latitude:</strong> {currentLocation.lat}
                </div>

                <div className="mb-3">
                  <strong>Longitude:</strong> {currentLocation.lng}
                </div>

                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={currentLocation}
                  zoom={16}
                >
                  <Marker position={currentLocation} />
                </GoogleMap>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeliveryTracking;
